// Use environment variable for API URL with fallback
// In production, this should be set to https://api.onlystatsvip.com
const API = process.env.REACT_APP_API_URL || "https://onlystats-api.onrender.com";

// Ensure the URL doesn't have a trailing slash
const formattedAPI = API.endsWith('/') ? API.slice(0, -1) : API;

export default formattedAPI;
